export const READ_ONLY_REVIEWER_ROLE = "reviewer";

export function isReadOnlyReviewer(userOrRole) {
  const role = typeof userOrRole === "string" ? userOrRole : userOrRole?.role;
  return role === READ_ONLY_REVIEWER_ROLE;
}

export function getRoleLabel(role) {
  const labels = {
    admin: "Admin",
    project_manager: "Project Manager",
    field_lead: "Field Lead",
    technician: "Technician",
    accounting: "Accounting",
    [READ_ONLY_REVIEWER_ROLE]: "Read-Only Reviewer",
  };
  return labels[role] || role?.replaceAll("_", " ") || "User";
}

export function canAccessRoleGate(user, { adminOnly = false, allowedRoles = null, allowReviewer = true } = {}) {
  if (!user) return false;
  if (isReadOnlyReviewer(user)) return allowReviewer && !adminOnly;
  if (adminOnly) return user.role === "admin";
  return !allowedRoles || user.role === "admin" || allowedRoles.includes(user.role);
}
